import { BasePropertyApi } from './base-api.interface';
import { getLockedState } from './get-common-properties';
import { updateLockedState } from './update-common-properties';

export const lockedAPI: BasePropertyApi = {
  get: getLockedState,
  update: updateLockedState,
};
